/**
 * The columns the contacts board always has.
 *
 * Two kinds of column exist and the difference is where they are stored, not
 * how they behave. A *declared field* is a row in `contact_fields` — an
 * organisation invented it, so it can be renamed, retyped and deleted. These
 * six are the contacts table's own columns: an organisation can rename them,
 * because a name is a label, and cannot delete them, because the data would
 * still be there and the board would have no way back to a contact.
 *
 * Here rather than in the front end because two things need the list and they
 * must agree. The board draws it; the route that stores a rename refuses an id
 * that is not in it, so the label table cannot fill up with names for columns
 * that do not exist.
 *
 * **A label is not a key.** A segment rule names a field, never a label, which
 * is why renaming a column cannot change who a campaign reaches. The same
 * separation `contact_fields` has had since it existed, for the same reason.
 */
/**
 * What a contact already fills in for itself, so a declared field may not
 * claim it.
 *
 * `renderMessage` writes these from the recipient, so a field keyed \n * would save and then never appear — the recipient's own name wins.
 */
export const RESERVED_CONTACT_KEYS = ['name', 'email', 'unsubscribe_url'];
const order = (column) => ({
    column,
    key: undefined,
    direction: 'asc',
});
export const BASE_COLUMNS = [
    { id: 'name', defaultLabel: 'Name', sort: order('name'), fixed: true, bulkEdit: undefined },
    { id: 'email', defaultLabel: 'Email', sort: order('email'), fixed: false, bulkEdit: undefined },
    {
        id: 'company',
        defaultLabel: 'Company',
        sort: order('company'),
        fixed: false,
        bulkEdit: 'company',
    },
    {
        id: 'segments',
        defaultLabel: 'Segments',
        sort: undefined,
        fixed: false,
        bulkEdit: undefined,
    },
    {
        id: 'status',
        defaultLabel: 'Subscription',
        sort: order('status'),
        fixed: false,
        bulkEdit: 'status',
    },
    {
        id: 'receiving',
        defaultLabel: 'Receiving',
        sort: undefined,
        fixed: false,
        bulkEdit: undefined,
    },
];
/** Whether an id names one of these, which is what a rename may be stored for. */
export function isBaseColumn(id) {
    return BASE_COLUMNS.some((column) => column.id === id);
}
//# sourceMappingURL=contactColumns.js.map